import axios from "axios";

export const login = (data) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/Login`, data);
  };

  export const tenant = (uniqueId) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Tenant/${uniqueId}`);
  };